/// <reference path="../../typings/index.d.ts" />

module monitoringApp.common {
    export function StatusFilter() {
        return (runTasks: entities.IRunCase[], status: string): entities.IRunCase[] => {

            if (!status || status === "all") { return runTasks; }
            if (status === "passed") {
                return runTasks.filter((task) => {
                    return task.status === 3;
                })
            }
            if (status === "failed") {
                return runTasks.filter((task) => {
                    return task.status > 3;
                })
            }

            return [];
        }
    }
    angular.module("ultimateMonitoringApp").filter("statusFilter", StatusFilter);

}
